import { useQuery } from "@tanstack/react-query";
import { ProjectsService } from "../generated";
import { tenantKeys } from "./tenants";

const projectKeys = {
  base: (tenantId: string) =>
    [...tenantKeys.detail(tenantId), "projects", "v1"] as const,
  nextProjectNumber: (tenantId: string) =>
    [...projectKeys.base(tenantId), "nextProjectNumber"] as const,
};

export function useNextProjectNumber(tenandId: string) {
  return useQuery({
    queryKey: projectKeys.nextProjectNumber(tenandId),
    queryFn: async () => ProjectsService.getNextProjectNumber(tenandId),
  });
}
